import { render, staticRenderFns } from "./VirtualCallPopup.vue?vue&type=template&id=c03dfda2&scoped=true&"
import script from "./VirtualCallPopup.vue?vue&type=script&lang=js&"
export * from "./VirtualCallPopup.vue?vue&type=script&lang=js&"
import style0 from "./VirtualCallPopup.vue?vue&type=style&index=0&id=c03dfda2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03dfda2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c03dfda2')) {
      api.createRecord('c03dfda2', component.options)
    } else {
      api.reload('c03dfda2', component.options)
    }
    module.hot.accept("./VirtualCallPopup.vue?vue&type=template&id=c03dfda2&scoped=true&", function () {
      api.rerender('c03dfda2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VirtualCallPopup/VirtualCallPopup.vue"
export default component.exports